import { table } from './_table';

export const payments = {
  namespaced: true,
  modules: {
    table
  }
};
